<template>
<div class="flex flex-col items-center pt-32">
    <div ref="form" class="py-4 w-full md:w-2/3 lg:w-1/3">
        <van-cell-group class="shadow-md" inset>
            <van-field v-model="email" maxlength="100" :label="lang[langCode].emailLabel" :placeholder="lang[langCode].emailMessage" />
        </van-cell-group>
    </div>
    <div v-if="ok" class="text-blue-500 italic text-sm">{{ lang[langCode].successSend }}</div>
    <van-button class="my-12 w-32" type="primary" :loading="sent" :disabled="sent" @click="send()">
        {{ lang[langCode].send }}
    </van-button>
</div>
</template>

<script>
import lang from "@/langs/PageResetLang.js";
import {
    ref,
    computed
} from "vue";
import {
    useStore
} from "vuex";
import {
    Button,
    Field,
    CellGroup,
    Notify
} from "vant";
import Reset from "@/asyncs/SendReset.js";

export default {
    components: {
        [Button.name]: Button,
        [Field.name]: Field,
        [CellGroup.name]: CellGroup
    },
    setup() {
        const store = useStore();
        store.commit("showBack");
        store.commit("hideMenu");
        store.commit("setPageTitle", lang[store.state.lang].title);

        const email = ref("");
        const sent = ref(false);
        const ok = ref(false);

        const send = async function () {
            if (!email.value) {
                Notify({
                    type: "danger",
                    message: lang[store.state.lang].emailMessage
                });
                return;
            }
            sent.value = true;
            email.value = email.value.toLowerCase();
            const error = await Reset(email.value);
            if (error) {
                Notify({
                    type: "danger",
                    message: lang[store.state.lang].failSend + error
                });
            } else {
                ok.value = true;
            }
        };

        return {
            lang,
            langCode: computed(() => store.state.lang),
            email,
            send,
            sent,
            ok
        };
    }
}
</script>
